import { orange } from '@mui/material/colors';
import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    onDashboard: boolean;
  }>()
  .create(({ theme, onDashboard }) => ({
    dashboardInternal: {
      minHeight: 416,
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(2)
    },
    headerRight: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: theme.spacing(2)
    },
    text: {
      color: theme.vars.palette.text.primary,
      paddingTop: theme.spacing(1)
    },
    quickSearch: {
      padding: onDashboard ? theme.spacing(2) : theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '20%',
      height: onDashboard ? 70 : 'auto',
      minWidth: 300,
      '&. MuiInputBase-root-searchInput': {
        height: onDashboard ? 70 : '40px'
      }
    },
    ticketsTableHeaderContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: theme.vars.palette.background.elevation1,
      position: 'sticky',
      top: 0,
      zIndex: 100
    },
    ticketsTableContainer: {
      marginTop: theme.spacing(2),
      backgroundColor: theme.vars.palette.background.elevation2,
      overflow: 'hidden',
      minHeight: onDashboard ? 500 : 100,
      display: 'flex',
      flexDirection: 'column',
      flex: 1
    },
    ticketsTable: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      flex: 1,
      borderTop: `solid 1px ${theme.vars.palette.border.light}`,
      '& .MuiTablePagination-root': {
        overflow: 'hidden'
      },
      '& .MuiDataGrid-filler': {
        display: onDashboard ? 'auto' : 'none'
      },
      '& .MuiStack-root': {
        height: onDashboard ? '' : '500px'
      }
    },
    teamQueueTicketsTable: {
      width: '100%',
      height: onDashboard ? 515 : 'auto',
      '& .MuiDataGrid-cell': {
        fontSize: '1.1rem',
        paddingTop: '0!important'
      },
      '& .MuiDataGrid-filler': {
        display: 'none'
      },
      '& .MuiDataGrid-scrollbar--vertical': {
        display: 'none'
      },
      '& .riskyTickets': {
        color: theme.vars.palette.error.main,
        fontWeight: 'bold',
        paddingTop: onDashboard ? '0!important' : '0.5rem'
      },
      '& .openTickets': {
        color: theme.vars.palette.info.main,
        fontWeight: 'bold',
        paddingTop: onDashboard ? '0!important' : '0.5rem'
      },
      '& .nextActionOwnerTickets': {
        color: '#9ACD32',
        fontWeight: 'bold',
        paddingTop: onDashboard ? '0!important' : '0.5rem'
      },
      '& .dueNowTickets': {
        color: orange[300],
        fontWeight: 'bold',
        paddingTop: onDashboard ? '0!important' : '0.5rem'
      },
      '& .pastDueTickets': {
        color: theme.vars.palette.warning.main,
        fontWeight: 'bold',
        paddingTop: onDashboard ? '0!important' : '0.5rem'
      }
    }
  }));

export default useStyles;
